<template>
    <modal :saveAction="save" :title="$t(title)" :id="id" :actionButtons="true" size="lg" scrollable @shown="shown" @hidden="hidden">
        <div class="row align-items-top">
            <div class="col-12">
                <b-form-textarea v-model="cancelExplanation"></b-form-textarea>
            </div>
        </div>
    </modal>
</template>

<script>
    import Money from "@/components/Money.vue";
    import Modal from "@/components/Modal.vue";
    import {mapActions} from 'vuex';

    export default {
        name: 'RemoveModal',
        props: {id: String},
        components: {
            Money,
            Modal,
        },
        watch: {},
        computed: {},
        data() {
            return {
                title: 'Reason for cancelling',
                data: {},
                cancelExplanation: ''
            }
        },
        created() {
        },

        methods: {
            ...mapActions('labs', ['patch']),

            save() {
                this.patch([this.data._id, {status: 'cancelled', cancelExplanation: this.cancelExplanation}]).then(() => {
                    this.close();
                })
            },

            close() {
                this.$root.$emit('bv::hide::modal', this.id)
            },

            shown() {
                const {Lab} = this.$FeathersVuex;
                let data = Lab.getFromStore('temp');

                if (data) {
                    delete data._id;
                    this.data = this.$copy(data.model);
                    new Lab({
                        model: {},
                        _id: 'temp'
                    });
                }

                this.cancelExplanation = ''
            },

            hidden() {

            }
        }
    }
</script>
